import { render, staticRenderFns } from "./CategoryModals.vue?vue&type=template&id=6b9d60d7&"
import script from "./CategoryModals.vue?vue&type=script&lang=js&"
export * from "./CategoryModals.vue?vue&type=script&lang=js&"
import style0 from "./CategoryModals.vue?vue&type=style&index=0&id=6b9d60d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports